/**
 * Script loading and execution utilities for user config scripts
 * Uses ipa-core's ScriptHelper instead of reimplementing
 */

import { ScriptHelper } from '@invicara/ipa-core/esm_modules/IpaUtils';
import { IafScriptEngine } from '@dtplatform/iaf-script-engine';

/**
 * Load and execute config-level scripts from user config
 * This is called when a project/config is loaded
 */
export async function loadConfigScripts(config: any): Promise<void> {
  if (!config) return;

  // Load all config level scripts
  if (config.onConfigLoad?.load && Array.isArray(config.onConfigLoad.load)) {
    console.log(`Loading ${config.onConfigLoad.load.length} config scripts...`);

    const loadThese = config.onConfigLoad.load;
    for (let i = 0; i < loadThese.length; i++) {
      try {
        await ScriptHelper.loadScript({ _userType: loadThese[i] });
      } catch (error) {
        console.error(`Failed to load config script: ${loadThese[i]}`, error);
        // Continue loading other scripts even if one fails
      }
    }
  }

  // Execute all config level scripts
  if (config.onConfigLoad?.exec && Array.isArray(config.onConfigLoad.exec)) {
    console.log(`Executing ${config.onConfigLoad.exec.length} config scripts...`);

    const execThese = config.onConfigLoad.exec;
    for (let i = 0; i < execThese.length; i++) {
      try {
        await ScriptHelper.executeScript(execThese[i]);
      } catch (error) {
        console.error(`Failed to execute config script:`, execThese[i], error);
        // Continue executing other scripts even if one fails
      }
    }
  }
}

/**
 * Check if project uses next-gen JavaScript engine
 * Uses ipa-core's implementation
 */
export function isProjectNextGenJs(): boolean {
  return ScriptHelper.isProjectNextGenJs();
}

/**
 * Clear all script engine variables and cache
 * Should be called when switching projects
 */
export function clearScriptState(): void {
  try {
    IafScriptEngine.clearVars();
    console.log('Cleared script engine state');
  } catch (error) {
    console.error('Failed to clear script state:', error);
  }
}

// Re-export ScriptHelper for convenience
export { ScriptHelper };
